// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let ReactRelay = require("react-relay");
let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");

function makeRefetchVariables(searchTerm) {
  return {
    searchTerm: searchTerm
  };
}

let Types = {
  makeRefetchVariables: makeRefetchVariables
};

let variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"propertySearchAreasAutocomplete":{"f":""}}};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, undefined, null);
}

let responseConverter = {"__root":{"propertySearchAreasAutocomplete":{"f":""}}};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, undefined, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: undefined,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: undefined,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchTerm"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "searchTerm",
    "variableName": "searchTerm"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PropertySearchAreasAutocompleteAreasEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Area",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      (v5/*: any*/)
    ],
    "storageKey": null
  },
  (v6/*: any*/)
],
v8 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v9 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PropertySearchAreasAutocompleteAreasEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Area",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nodeId",
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      (v5/*: any*/)
    ],
    "storageKey": null
  },
  (v6/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PropertiesFiltersAreasAutocompleteQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PropertySearchAreasAutocompleteResult",
        "kind": "LinkedField",
        "name": "propertySearchAreasAutocomplete",
        "plural": false,
        "selections": [
          {
            "kind": "InlineDataFragmentSpread",
            "name": "PropertiesFiltersAreasAutocomplete_propertiesFilters_areas",
            "selections": [
              {
                "alias": "areas",
                "args": null,
                "concreteType": "PropertySearchAreasAutocompleteAreasConnection",
                "kind": "LinkedField",
                "name": "__PropertyFiltersAreasAutocomplete_areas_connection",
                "plural": false,
                "selections": (v7/*: any*/),
                "storageKey": null
              }
            ],
            "args": null,
            "argumentDefinitions": []
          },
          {
            "kind": "InlineDataFragmentSpread",
            "name": "PropertiesFiltersAreasAutocomplete_propertiesFilters_schools",
            "selections": [
              {
                "alias": "schools",
                "args": null,
                "concreteType": "PropertySearchAreasAutocompleteAreasConnection",
                "kind": "LinkedField",
                "name": "__PropertyFiltersAreasAutocomplete_schools_connection",
                "plural": false,
                "selections": (v7/*: any*/),
                "storageKey": null
              }
            ],
            "args": null,
            "argumentDefinitions": []
          },
          {
            "kind": "InlineDataFragmentSpread",
            "name": "PropertiesFiltersAreasAutocomplete_propertiesFilters_schoolDistricts",
            "selections": [
              {
                "alias": "schoolDistricts",
                "args": null,
                "concreteType": "PropertySearchAreasAutocompleteAreasConnection",
                "kind": "LinkedField",
                "name": "__PropertyFiltersAreasAutocomplete_schoolDistricts_connection",
                "plural": false,
                "selections": (v7/*: any*/),
                "storageKey": null
              }
            ],
            "args": null,
            "argumentDefinitions": []
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PropertiesFiltersAreasAutocompleteQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PropertySearchAreasAutocompleteResult",
        "kind": "LinkedField",
        "name": "propertySearchAreasAutocomplete",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v8/*: any*/),
            "concreteType": "PropertySearchAreasAutocompleteAreasConnection",
            "kind": "LinkedField",
            "name": "areas",
            "plural": false,
            "selections": (v9/*: any*/),
            "storageKey": "areas(first:100)"
          },
          {
            "alias": null,
            "args": (v8/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "PropertyFiltersAreasAutocomplete_areas",
            "kind": "LinkedHandle",
            "name": "areas"
          },
          {
            "alias": null,
            "args": (v8/*: any*/),
            "concreteType": "PropertySearchAreasAutocompleteAreasConnection",
            "kind": "LinkedField",
            "name": "schools",
            "plural": false,
            "selections": (v9/*: any*/),
            "storageKey": "schools(first:100)"
          },
          {
            "alias": null,
            "args": (v8/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "PropertyFiltersAreasAutocomplete_schools",
            "kind": "LinkedHandle",
            "name": "schools"
          },
          {
            "alias": null,
            "args": (v8/*: any*/),
            "concreteType": "PropertySearchAreasAutocompleteAreasConnection",
            "kind": "LinkedField",
            "name": "schoolDistricts",
            "plural": false,
            "selections": (v9/*: any*/),
            "storageKey": "schoolDistricts(first:100)"
          },
          {
            "alias": null,
            "args": (v8/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "PropertyFiltersAreasAutocomplete_schoolDistricts",
            "kind": "LinkedHandle",
            "name": "schoolDistricts"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e41fb9bdbbbe0419950caf41ca46c32c",
    "id": null,
    "metadata": {},
    "name": "PropertiesFiltersAreasAutocompleteQuery",
    "operationKind": "query",
    "text": "query PropertiesFiltersAreasAutocompleteQuery(\n  $searchTerm: String!\n) {\n  propertySearchAreasAutocomplete(searchTerm: $searchTerm) {\n    ...PropertiesFiltersAreasAutocomplete_propertiesFilters_areas\n    ...PropertiesFiltersAreasAutocomplete_propertiesFilters_schools\n    ...PropertiesFiltersAreasAutocomplete_propertiesFilters_schoolDistricts\n  }\n}\n\nfragment PropertiesFiltersAreasAutocomplete_propertiesFilters_areas on PropertySearchAreasAutocompleteResult {\n  areas(first: 100) {\n    edges {\n      node {\n        id\n        label\n        nodeId\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment PropertiesFiltersAreasAutocomplete_propertiesFilters_schoolDistricts on PropertySearchAreasAutocompleteResult {\n  schoolDistricts(first: 100) {\n    edges {\n      node {\n        id\n        label\n        nodeId\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment PropertiesFiltersAreasAutocomplete_propertiesFilters_schools on PropertySearchAreasAutocompleteResult {\n  schools(first: 100) {\n    edges {\n      node {\n        id\n        label\n        nodeId\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})());

function load(environment, variables, fetchPolicy, fetchKey, networkCacheConfig) {
  return ReactRelay.loadQuery(environment, node, convertVariables(variables), {
    fetchKey: fetchKey,
    fetchPolicy: fetchPolicy,
    networkCacheConfig: networkCacheConfig
  });
}

function queryRefToObservable(token) {
  return Primitive_option.fromNullable(token.source);
}

function queryRefToPromise(token) {
  return new Promise((resolve, _reject) => {
    let o = queryRefToObservable(token);
    if (o !== undefined) {
      Primitive_option.valFromOption(o).subscribe({
        complete: () => resolve({
          TAG: "Ok",
          _0: undefined
        })
      });
      return;
    } else {
      return resolve({
        TAG: "Error",
        _0: undefined
      });
    }
  });
}

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
exports.load = load;
exports.queryRefToObservable = queryRefToObservable;
exports.queryRefToPromise = queryRefToPromise;
/* node Not a pure module */
